import { css } from '@emotion/css';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../features';
import { actions } from '../../features/reaction';
import { Loading } from '../shared/Loading';
import { LoadingFailed } from '../shared/LoadingFailed';
import { DialogRoute } from '../shared/routes/DialogRoute';
import { TitleHeader } from '../shared/TitleHeader';
import { ReactionContent } from './ReactionContent';
import { ReactionErrorDialog } from './ReactionErrorDialog';
import { ReactionHintDialog } from './ReactionHintDialog';

const Reaction: React.FC = () => {
  const { t } = useTranslation(['reaction', 'translation']);
  const { reactionItems } = useSelector((state: RootState) => state.reaction);
  const dispatch = useDispatch();

  useEffect(() => {
    if (reactionItems?.state !== 'ok') {
      dispatch(actions.getReactions());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <>
      <main
        className={css`
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 100%;
          color: #4d3906;
          background-color: #f5e0ff;

          .body {
            display: flex;
            justify-content: center;
            flex: 1 1 auto;
            height: 100%;
            overflow-x: hidden;
            overflow-y: scroll;
          }
        `}
      >
        <TitleHeader
          title={t('top')}
          hintPath="/players/reaction/hint"
          hintLabel={t('aria_help')}
          backLabel={t('translation:aria_button_back_to_previous')}
          color={'#ecc6ff'}
        />
        <div className="body">
          {(() => {
            switch (reactionItems?.state) {
              case 'ok':
                return <ReactionContent items={reactionItems.result} />;
              case 'pending':
                return <Loading />;
              case 'error':
                return <LoadingFailed error={reactionItems.error} />;
              default:
                return <></>;
            }
          })()}
        </div>
      </main>

      <DialogRoute path="/players/reaction/hint">
        <ReactionHintDialog />
      </DialogRoute>
      <DialogRoute path="/players/reaction/error">
        <ReactionErrorDialog />
      </DialogRoute>
    </>
  );
};

export default Reaction;
